import React, { useState } from "react";
import SearchBar from "../../components/SearchBar";
import Navbar from "../../components/Navbar";
import hamburger_icon from "../../assets/icons/hamburger_icon.png";
import { Link } from "react-router-dom";

const CreateSMSGetaway = () => {
  const [isNavbarVisible, setIsNavbarVisible] = useState(false);

  const toggleNavbar = () => {
    setIsNavbarVisible(!isNavbarVisible);
  };

  return (
    <div>
      <div className="flex items-center justify-center w-full">
        <div
          className="items-center justify-center hidden hamburger"
          onClick={toggleNavbar}
        >
          <img
            src={hamburger_icon}
            alt="hamburger"
            className="object-contain"
          />
        </div>
        <div className="flex items-center justify-center w-full">
          <SearchBar categoryName="Profile" />
        </div>
        <div className="absolute top-0 w-[70%] z-20 bg-white rounded-lg mt-16">
          {isNavbarVisible && <Navbar />}
        </div>
      </div>

      <div className="ml-4 mt-10">
        <p className="text-[18px] font-bold">SMS Getaway</p>
      </div>

      <div className="w-[70%] ml-4 mt-10">
        <div className="mt-2">
          <p className="text-[14px]">SMS Title</p>
          <input
            type="text"
            placeholder="Enter the SMS title"
            className="border w-full p-2 rounded-lg border-[#95C2FF] text-[16px]"
          />
        </div>
        <div className="mt-4">
          <p className="text-[14px]">SMS Content</p>
          <input
            type="text"
            placeholder="Enter the SMS content"
            className="border w-full p-2 rounded-lg border-[#95C2FF] text-[16px]"
          />
        </div>
      </div>

      <div className="mb-10 ml-4 w-[70%]">
        <div className=" mt-4 flex w-full justify-between items-center create-foot">
          <div className="text-[#2F80ED] text-[16px] underline font-bold cursor-pointer mt-8">
            Save & Create New
          </div>
          <div className="flex text-[14px] w-[50%] justify-end mt-8">
            <button className=" bg-white text-[#2F80ED] font-bold border border-[#95C2FF] p-2 rounded-lg w-[30%] action--buttons">
              Discard
            </button>
            <Link
              to="/profile/sms-template"
              className="bg-[#2F80ED] ml-2 p-2 text-white rounded-lg w-[30%] text-center action--buttons"
            >
              Send
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateSMSGetaway;
